import IProgram from "../../models/Program";
import transformSession from "./session";

const transformNewProgram = (data: any, id: any): IProgram => {
    const program = data.programBatch?.program;
    console.log('program', program);
    
    const batch = data.programBatch ? data.programBatch.filter((el: any) => el.id === Number(id)) : [];
    console.log('batch', batch);
    
    const programMeta = data.programMeta ? data.programMeta : program?.programMeta ? program?.programMeta : {};
    console.log('programMeta', programMeta);
    
    return {
        id: program?.id ?? batch[0]?.programId ?? 0,
        programBatchId: data.programBatch?.id ?? batch[0]?.id ?? 0,
        name: data?.program_name ??  "Unnamed Program",
        batchName: data.programBatch?.batch_name ?? batch[0]?.batch_name ?? "Unnamed Batch",
        category:
            programMeta?.nature_name?.toLowerCase() ?? "other",
        sessions: data?.sessionList?.map((el: any) => transformSession(el)) ?? [],
        batch: {
            id: batch[0]?.id ?? 0,
            name: batch[0]?.batch_name ?? "Unnamed Batch",
        },
        // myRating: data.programme_rating ?? 0, // default to 0 if not provided
        // groupRating: 0, // Replace with actual field if available
        // engagement: 0, // Replace with actual field if available
        mode: programMeta?.program_mode?.toLowerCase() ?? "unknown",
        startDate: data?.from_date ?? null,
        endDate: data?.to_date ?? null,
        status: data?.status ?? "Not available",
    };
};

export default transformNewProgram;
